import {Component, OnInit} from '@angular/core';
import Amplify, {Auth} from 'aws-amplify';
import {environment} from '../environments/environment';
import {Title} from '@angular/platform-browser';

declare var app: any

Amplify.configure({

  // REQUIRED - Amazon Cognito Region
  region: environment.region,
  // OPTIONAL - Amazon Cognito User Pool ID
  userPoolId: environment.userPoolId,
  // OPTIONAL - Amazon Cognito Web Client ID
  userPoolWebClientId: environment.userPoolWebClientId
});

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Achelos IoT';

  constructor(private mainTitle: Title) {
  }

  ngOnInit() {
    if (app === 'achelos') {
      this.mainTitle.setTitle('achelos');
      document.getElementById('index-favicon').setAttribute('href', 'assets/favicon.ico');
    } else if (app === 'nordic') {
      this.mainTitle.setTitle('Nordic eSIM');
      document.getElementById('index-favicon').setAttribute('href', 'customers/nordic/nordic-favicon.png');
    } else if (app === 'inkript') {
      this.mainTitle.setTitle('Inkript');
      document.getElementById('index-favicon').setAttribute('href', 'customers/inkript/inkript-favicon.png');
    }  else if (app === 'nordic-workz') {
      this.mainTitle.setTitle('Workz eSIM');
      document.getElementById('index-favicon').setAttribute('href', 'customers/workz/workz-favicon.png');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts